import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

const ERROR_CODE_PARAM = 'code';
const RESPONSE_PARAM = 'response';

@Component({
	selector: 'unauthorized',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './unauthorized.component.html',
	styleUrls: ['./unauthorized.component.css'],
})
export class UnauthorizedComponent implements OnInit {
	constructor(private route: ActivatedRoute) {}
	@Input() code = '';
	@Input() response = '';

	ngOnInit() {
		// Using snapshot instead of subscribe
		this.code = this.route.snapshot.queryParams[ERROR_CODE_PARAM] || 'Unknown';
		this.response = this.route.snapshot.queryParams[RESPONSE_PARAM] || '';
		try {
			console.error(JSON.parse(this.response));
		} catch (err) {
			console.error('An unknown error occurred');
		}
	}

	canGoBack() {
		return window.history.length > 1;
	}

	goBack() {
		window.history.back();
	}
}
